import ParameterNameGenerator from "@tool/Helpers/ParameterNameGenerator";
import {ProjectBuilderSettingsInterface, ParameterEntityInterface, TemplateEntityInterface} from "@tool/tool.types";
import {BuilderParameterInterface, BuilderTemplateInterface} from "@tool/Builder/Builder.types";

export interface SelectOption {
    name: string;
    notes?: string | null;
    utm_string?: string;
}

export interface NewParameterDisplay {
    generateName: (parameter: string) => string;
    displaySlugifySuggestion: (parameter: string) => boolean
}

export interface SelectDropdownInit {
    type: string;
    placeholderText: string;
    noOptionsText: string;
    taggable: boolean;
    options: SelectOption[],
    newParameterDisplay?: NewParameterDisplay;
}

export function SelectDropdownInitTemplate(templates: BuilderTemplateInterface[]): SelectDropdownInit {

    return {
        type: 'utm_template',
        placeholderText: 'Select a template (optional)',
        noOptionsText: 'You haven\'t saved any templates yet. Choose parameters below and then save combination using the link at the bottom of this section to save time in the future.',
        options: templates,
        taggable: false
    }
}

export function SelectDropdownInitParameter(type: string, parameters: BuilderParameterInterface[], settings: ProjectBuilderSettingsInterface): SelectDropdownInit {
    return {
        type,
        placeholderText: `Add or choose ${type}`,
        taggable: true,
        noOptionsText: `You haven't saved any ${type} parameters yet. Start typing and press enter to add it to the library.`,
        options: parameters,
        newParameterDisplay: {
            generateName(parameterName) {
                return ParameterNameGenerator(parameterName, settings, true);
            },
            displaySlugifySuggestion(parameterName) {
                return ParameterNameGenerator(parameterName, settings, false) !== ParameterNameGenerator(parameterName, settings, true);
            }
        }
    }
}